import React, { useState } from 'react'
import {Modal} from 'antd';
import { useNewsClickMutation } from '../store/ReactWebSiteApi';
import NewsDesc from './NewsDesc';
function WebNewsCheck(props) {
    const [open,setOpen] = useState(false)
    //点击量
    const [add] = useNewsClickMutation()
    return (
        <>
            <a  
                onClick={() => {
                    add({
                        en_id:props.en_id
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                    
                            console.log('success');
                        }
                        if (res.data.Status === 'fail') {
                            console.log(res.data.Message)
                        }
                    })
                    setOpen(true)
                }}
                style={{fontSize:"24px"}}
            >{props.text}</a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <NewsDesc
                    en_id={props.en_id}
                />             
            </Modal>
        </>
    )
}

export default WebNewsCheck